export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400">
            About / 01
          </p>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
            Why SilentScan AI?
          </h2>
        </div>
        <div className="lg:col-span-8">
          <p className="font-display text-2xl sm:text-3xl lg:text-4xl leading-[1.25] tracking-tight text-zinc-100 font-light">
            Millions of people discover health conditions{" "}
            <span className="text-zinc-500">only after symptoms become serious.</span>{" "}
            SilentScan AI encourages{" "}
            <span className="text-gradient-cyan font-medium">preventive healthcare</span>{" "}
            by helping users understand potential health risks earlier — and adopt
            healthier habits before it's too late.
          </p>

          <div className="mt-12 grid grid-cols-3 gap-6 md:gap-10 max-w-2xl">
            {[
              { stat: "60%", label: "Chronic diseases are preventable" },
              { stat: "5×", label: "Better outcomes with early insight" },
              { stat: "24/7", label: "AI-powered awareness" },
            ].map((s) => (
              <div key={s.label}>
                <p className="font-display text-3xl md:text-4xl font-semibold text-white">
                  {s.stat}
                </p>
                <p className="text-xs md:text-sm text-zinc-500 mt-2 leading-snug">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
